import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ShowToast } from '../../common/Toastr';
import { displayValueForTimeEntry, getDecimalFromTime, getDecimalFromTimeInImportTimesheet } from '../../common/timesheetFunction';
import CsvDownloader from 'react-csv-downloader';
import { usePapaParse } from 'react-papaparse';
import { updateIsLoading, addImportedAccountEmployeeTimeEntryAsync, getTimeEntriesByPeriodIdAsync, getTimesheetPeriodAsync } from './timesheetSlice';
import { t } from 'i18next';
import { getValueFromResource } from '../../common/timeLiveFunction';
import fetchAPI from '../../common/fetchAPI';
const headerColumns = [{
    id: 'TimeEntryDate',
    displayName: 'TimeEntryDate'
}, {
    id: 'ProjectName',
    displayName: 'ProjectName'
}, {
    id: 'TaskName',
    displayName: 'TaskName'
},{
   
    id: 'TaskNameWithAdditionalInfo',
    displayName: 'TaskNameWithAdditionalInfo'
},{
    id: 'Description',
    displayName: 'Description'
}, {
    id: 'StartTime',
    displayName: 'StartTime'
}, {
    id: 'EndTime',
    displayName: 'EndTime'
}, {
    id: 'TotalTime',
    displayName: 'TotalTime'
}, {
    id: 'CostCenter',
    displayName: 'AccountCostCenter'
}, {
    id: 'WorkType',
    displayName: 'AccountWorkType'
}, {
    id: 'CustomField1',
    displayName: 'CustomField1'
}, {
    id: 'CustomField2',
    displayName: 'CustomField2'
}, {
    id: 'CustomField3',
    displayName: 'CustomField3'
}, {
    id: 'CustomField4',
    displayName: 'CustomField4'
}, {
    id: 'CustomField5',
    displayName: 'CustomField5'
}, {
    id: 'CustomField6',
    displayName: 'CustomField6'
}, {
    id: 'CustomField7',
    displayName: 'CustomField7'
}, {
    id: 'CustomField8',
    displayName: 'CustomField8'
}, {
    id: 'CustomField9',
    displayName: 'CustomField9'
}, {
    id: 'CustomField10',
    displayName: 'CustomField10'
}, {
    id: 'CustomField11',
    displayName: 'CustomField11'
}, {
    id: 'CustomField12',
    displayName: 'CustomField12'
}, {
    id: 'CustomField13',
    displayName: 'CustomField13'
}, {
    id: 'CustomField14',
    displayName: 'CustomField14'
}, {
    id: 'CustomField15',
    displayName: 'CustomField15'
}];

const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
    let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
    if (!foundItem) return customFieldData;
    if (
        foundItem?.MasterCustomDataTypeName === 'Date' ||
        foundItem?.MasterCustomDataTypeName === 'DateTime'
    ) {
        if (customFieldData instanceof Date) {
            const yyyy = customFieldData.getFullYear();
            const mm = String(customFieldData.getMonth() + 1).padStart(2, '0');
            const dd = String(customFieldData.getDate()).padStart(2, '0');

            const dateOnly = `${yyyy}-${mm}-${dd}`;
            return `="${dateOnly}"`;
        }

        if (typeof customFieldData === 'string') {
            const dateOnly = customFieldData.split(' ')[0];
            return `="${dateOnly}"`;
        }
    }

    else if (foundItem.MasterCustomDataTypeName === 'Number') {
        if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
            return customFieldData.replace(',', '.');
        }
    }
    else if (foundItem?.MasterCustomDataTypeName === 'Drop-Down') {
        const safeValue1 = String(customFieldData).replace(/"/g, '""');
        return `"${safeValue1}"`;
    }      
    
    else if (foundItem?.MasterCustomDataTypeName === 'Text') {
        const safeValue = String(customFieldData).replace(/"/g, '""');
        return `"${safeValue}"`;
    }
    else {
        return customFieldData;
    }
}




let fileExtensions = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
const TimesheetExportWidget = () => {
    const { timeEntriesList, accountEmployeeTimeEntryPeriodId, accountEmployeeId, decimalFormat, timeEntryViewType, isTimesheetPolicy, startDate, endDate } = useAppSelector((state => state.timesheet));
    const { customFieldsTemplate } = useAppSelector((state) => state.globalState);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const hiddenFileInput = useRef<any>(null);
    const { readString } = usePapaParse();
    let detailTimeEntries: any[] = [];
    const dispatch = useAppDispatch();

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync();
    }, []);


    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = '369ED0FB-D317-4244-9F20-B7D834521E2B';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }



    const exportTimesheet = () => {
        if (detailTimeEntries.length > 0) {
            detailTimeEntries = []
        }
        for (var i = 0; i < timeEntriesList.length; i++) {
            let obj = timeEntriesList[i];
            if (obj.TaskName != null) {
                obj.timeEntries.map((item: any) => {
                    let object: any = {
                        TimeEntryDate: '',
                        ProjectName: '',
                        TaskName: '',
                        TaskNameWithAdditionalInfo: '',
                        Description: '',
                        StartTime: '',
                        EndTime: '',
                        TotalTime: '',
                        CostCenter: '',
                        WorkType: '',
                        CustomField1: '',
                        CustomField2: '',
                        CustomField3: '',
                        CustomField4: '',
                        CustomField5: '',
                        CustomField6: '',
                        CustomField7: '',
                        CustomField8: '',
                        CustomField9: '',
                        CustomField10: '',
                        CustomField11: '',
                        CustomField12: '',
                        CustomField13: '',
                        CustomField14: '',
                        CustomField15: ''
                    }
                    object.ProjectName = obj.ProjectName;
                    // object.TaskName = obj.TaskName;
                    object.TaskNameWithAdditionalInfo = obj.TaskName; // Isme full name (with bracket) jayega

                    // Agar string me bracket '(' maujood hai toh clean karein, warna original rkhein
                    // if (obj.TaskName.includes('(')) {
                    //     // Regex bracket aur uske andar ki value ko remove karega aur trim() extra space saaf karega
                    //     object.TaskName = obj.TaskName.replace(/\s*\(.*?\)\s*/g, '').trim();
                    // } else {
                        object.TaskName = obj.TaskName;
                    // }
                    object.CostCenter = obj.CostCenter;
                    object.WorkType = obj.WorkType;
                    if (item.Hours > 0) {
                        object.TimeEntryDate = item.TimeEntryDate;
                        object.Description = `"${String(item.Description).replace(/"/g, '""')}"`;
                        object.StartTime = item.StartTime;
                        object.EndTime = item.EndTime;
                        object.TotalTime = displayValueForTimeEntry(item.Hours, isTimesheetPolicy, false);
                        object.CustomField1 = setCustomFieldValues('CustomField1', item.CustomField1, customFieldsArray);
                        object.CustomField2 = setCustomFieldValues('CustomField2', item.CustomField2, customFieldsArray);
                        object.CustomField3 = setCustomFieldValues('CustomField3', item.CustomField3, customFieldsArray);
                        object.CustomField4 = setCustomFieldValues('CustomField4', item.CustomField4, customFieldsArray);
                        object.CustomField5 = setCustomFieldValues('CustomField5', item.CustomField5, customFieldsArray);
                        object.CustomField6 = setCustomFieldValues('CustomField6', item.CustomField6, customFieldsArray);
                        object.CustomField7 = setCustomFieldValues('CustomField7', item.CustomField7, customFieldsArray);
                        object.CustomField8 = setCustomFieldValues('CustomField8', item.CustomField8, customFieldsArray);
                        object.CustomField9 = setCustomFieldValues('CustomField9', item.CustomField9, customFieldsArray);
                        object.CustomField10 = setCustomFieldValues('CustomField10', item.CustomField10, customFieldsArray);
                        object.CustomField11 = setCustomFieldValues('CustomField11', item.CustomField11, customFieldsArray);
                        object.CustomField12 = setCustomFieldValues('CustomField11', item.CustomField11, customFieldsArray);
                        object.CustomField13 = setCustomFieldValues('CustomField13', item.CustomField13, customFieldsArray);
                        object.CustomField14 = setCustomFieldValues('CustomField14', item.CustomField14, customFieldsArray);
                        object.CustomField15 = setCustomFieldValues('CustomField15', item.CustomField15, customFieldsArray);
                    }
                    item.Hours > 0 && detailTimeEntries.push(object);
                });
            }
        }
    }

    const importTimesheet = () => {
        hiddenFileInput.current.click();
    }

    const validateImportTimesheetCSV = (results: any) => {
        let initialArrayFromCSV: any[] = [];
        initialArrayFromCSV.push(results.data[0]);
        let isCheckingEntries: boolean = true;
        headerColumns.map((items: any, index: number) => {
            if (!isCheckingEntries) {
                return;
            }
            if (!results.data.some((item: any) => item.hasOwnProperty(items.displayName))) {
                isCheckingEntries = false;
                ShowToast('Error', `Column "${Object.keys(initialArrayFromCSV[0])[index]}" is not valid. Use "${items.displayName}" instead`, "error", "toast-top-right");
                return null;
            }
        });
        if (isCheckingEntries) {
            results.data.map((item: any) => {
                if (!isCheckingEntries) {
                    return;
                }
                if (moment(item.TimeEntryDate).format('yyyy-MM-DD') >= startDate && moment(item.TimeEntryDate).format('yyyy-MM-DD') <= endDate) {
                } else if (item.TimeEntryDate == '') {
                    isCheckingEntries = false;
                    ShowToast('Error', `Value cannot be null. Parameter name: TimeEntryDate`, "error", "toast-top-right");
                    return;
                } else {
                    isCheckingEntries = false;
                    ShowToast('Error', `This date "${item.TimeEntryDate}" is not within the current date range`, "error", "toast-top-right");
                    return;
                }
                if (item.TotalTime == '') {
                    isCheckingEntries = false;
                    ShowToast('Error', `Value cannot be null. Parameter name: TotalTime`, "error", "toast-top-right");
                }
            });
        }
        if (isCheckingEntries) {
            results.data.map((item: any) => {
                for (let i = 1; i <= 15; i++) {
                    const fieldName = `CustomField${i}`;
                    const customField = customFieldsArray.find( (field: any) => field.DatabaseFieldName === fieldName );
            
                    if ( customField && (customField.MasterCustomDataTypeName === 'Date' || customField.MasterCustomDataTypeName === 'DateTime') ) {
                        if (item[fieldName]) {
                            item[fieldName] = item[fieldName].replace(/^="|"$/g, '').replace(/^"|"$/g, '').trim();
                        }
                    }
                }
                item.AccountEmployeeTimeEntryPeriodId = accountEmployeeTimeEntryPeriodId;
                item.AccountEmployeeTimeEntryId = 0;
                item.AccountEmployeeId = accountEmployeeId;
                item.AccountTimeOffTypeId = null;
                item.Hours = getDecimalFromTimeInImportTimesheet(item.TotalTime, decimalFormat)
                item.Percentage = null;
                item.PeriodStartDate = startDate;
                item.PeriodEndDate = endDate;
                item.IsTimeOff = false;
                item.TimesheetPeriodType = timeEntryViewType;
                item.IsSubmitted = false;
                item.RowId = 0;
                item.DetailRowId = 0;
                if (item.hasOwnProperty('TaskNameWithAdditionalInfo')) {
                    delete item.TaskNameWithAdditionalInfo;
                }
                delete item.TotalTime;
                item.SystemPlatformSourceId = "3D9FD131-9B80-43DA-AD66-CBE010F1B5A6"
            });
            dispatch(updateIsLoading(true));
            dispatch(addImportedAccountEmployeeTimeEntryAsync(results.data))
                .unwrap()
                .then((result) => {
                    if (result.id > 0) {
                        dispatch(getTimeEntriesByPeriodIdAsync());
                        dispatch(getTimesheetPeriodAsync());
                        ShowToast('Success', 'Timesheet imported successfully!', "success", "toast-top-right");
                    } else {
                        dispatch(updateIsLoading(false));
                        ShowToast('Error', result.message, "error", "toast-top-right");
                    }
                })
                .catch((rejectedValueOrSerializedError) => {
                    dispatch(updateIsLoading(false));
                })
                .finally(() => {
                });
        }
    }

    const getDataFromFile = (event: any) => {
        let csvFile = event.target.files[0];
        readString(csvFile, {
            //worker: true,
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                validateImportTimesheetCSV(results);
            }
        });
        hiddenFileInput.current.value = "";
    }

    return (
        <div className={"col-md-12 col-sm-12 col-xs-12"}>
            <h4 className="headerTitle">
                {/* {t('Import And Export Timesheet')} */}
                {getValueFromResource('Import And Export Timesheet',dispatch, t)}
                </h4>
            <div className="separator my-1"></div>
            <div className='d-flex align-items-center gap-2 gap-lg-3' style={{ marginTop: 10, marginLeft: 7 }}>
                <CsvDownloader
                    filename={accountEmployeeTimeEntryPeriodId != null ? accountEmployeeTimeEntryPeriodId : 'Timesheet_Export'}
                    extension=".csv"
                    columns={headerColumns}
                    datas={detailTimeEntries}
                >
                    <a onClick={() => { exportTimesheet() }} className={"btn btn-light-primary btn-sm"}>
                        <i className="bi bi-arrow-bar-down fs-5 me-1"></i>
                        {/* {t('Export Offline')} */}
                        {getValueFromResource('Export Offline',dispatch, t)}
                    </a>
                </CsvDownloader>
                <input
                    type="file"
                    ref={hiddenFileInput}
                    accept={fileExtensions}
                    onChange={(e) => { getDataFromFile(e) }}
                    style={{ display: 'none' }}
                />
                <a onClick={() => { importTimesheet() }} className={"btn btn-light-primary btn-sm"}>
                    <i className="bi bi-arrow-bar-up fs-5 me-1"></i>
                    {/* {t('Import Offline')} */}
                    {getValueFromResource('Import Offline',dispatch, t)}
                </a>
            </div>
        </div>
    )
}

export default TimesheetExportWidget